module.exports = __webpack_public_path__ + "img/fj.aaf03cd6.svg";